<div class="p-20">
  <div class="dialog-header p-16-20 flex bg-fff">
    <img [src]="images?.LOCKED_IMG" alt="Locked Plan" />
    <div class="dialog-header-cross" (click)="cancelClicked()">
      <img [src]="images?.CROSS" class="img-20" alt="close" />
    </div>
  </div>

  <div class="flex-center flex_column gap-4 locked-content">
    <div class="fs-24 fw-700 locked-title">
      {{ 'SIDENAV.LOCKED_FEATURE' | fallbackTranslate }}
    </div>
    <div
      class="fs-14 locked-sub-header ta_center"
      [innerHTML]="sanitizeHtml(subHeader)"
    ></div>

    <div
      class="flex flex_sb wd-100 gap-buttons"
      *ngIf="data?.type === enums.LOCKED_FEATURE_TYPE.EXPIRED"
    >
      <button
        class="flex flex-1 flex-center header-btn secondary fs-16 fw-600"
        (click)="talkToExpert()"
      >
        {{ 'SIDENAV.BUTTON_TALK_TO_SALES_TEAMS' | fallbackTranslate }}
      </button>
      <button
        class="flex flex-1 flex-center header-btn primary fs-16 fw-600"
        (click)="renew()"
      >
        {{ (!isNegative ? 'RENEW_NOW' : 'PAY_NOW') | fallbackTranslate }}
      </button>
    </div>

    <button
      *ngIf="data?.type === enums.LOCKED_FEATURE_TYPE.FREE_MENU_LEADS"
      class="header-btn primary fs-16 fw-600"
      (click)="upgrade()"
    >
      {{ 'SIDENAV.UPGRADE_NOW' | fallbackTranslate }}
    </button>
  </div>
</div>
